import Vue from "vue";
import { dataGather } from "@/utils/logTracking.js";

// 用法：v-track="'NRCU001|NRCU001-002|点击专家卡片'"
// 用竖线分隔"页面编号|事件编号|事件名称(可选，仅用于properties里备注，方便看日志时对得上人话)"
// 以后哪个按钮想加埋点，直接在标签上加这一个属性就行，不用每次手写dataGather调用
Vue.directive("track", {
  bind(el, binding) {
    if (!binding.value) return;
    let parts = String(binding.value).split("|");
    let page = parts[0];
    let event = parts[1];
    let eventName = parts[2] || "";
    el.addEventListener("click", () => {
      dataGather(page, event, eventName ? { eventName } : {});
    });
  },
});
